export default __webpack_public_path__ + "static/media/Fall_06.4cc6607a.png";